'use client';

import SettingConfig from '@module/config/setting';
import { darkThemeSafeLocalStorage } from '@module/lib/storage/storageImplementations';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import { useLayoutEffect, useState } from 'react';

function NotFoundImage() {
  const { isDark, darkModeChange } = useIsDarkModeStore();
  const [isMounted, setIsMounted] = useState(false);

  useLayoutEffect(() => {
    const curr = darkThemeSafeLocalStorage.get();
    const { body } = document;
    if (curr === 'dark') {
      body.setAttribute('data-theme', 'dark');
      darkModeChange(true);
    } else if (curr === 'light') {
      body.setAttribute('data-theme', 'light');
      darkModeChange(false);
    }
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;
  return (
    <img
      src={`${SettingConfig.S3_BUCKET_URL}/img/icon/not_found_404${isDark ? '_dark' : ''}.png`}
      alt=''
      height={100}
    />
  );
}

export default NotFoundImage;
